import { AxiosResponse } from 'axios';

import API from '../Api';
import { EmablerDataUI, EvChargingStatus, TransactionHistoryEventUI, TransactionHistoryRequestUI } from '../types/evCharging';
import { getUserToken, logUserOut } from '../utils/login';

export const fetchEVChargerInfo = async (dataOwnerCustomerId: number, actingCustomerId: number): Promise<EmablerDataUI> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const evChargerInfoRequest: AxiosResponse<EmablerDataUI> = await API({
    method: 'get',
    url: `/v1/evChargerInfo/${dataOwnerCustomerId}/${actingCustomerId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        logUserOut();
      }
      return error.response;
    }
  });

  return evChargerInfoRequest.data;
};

export const startEvCharging = async (
  dataOwnerCustomerId: number,
  actingCustomerId: number,
  chargerId: string,
  socketId: string,
  rfidTag: string,
): Promise<EvChargingStatus> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const evStartChargingRequest: AxiosResponse<EvChargingStatus> = await API({
    method: 'post',
    url: `/v1/evCharging-start/${dataOwnerCustomerId}/${actingCustomerId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      chargerId,
      socketId,
      rfidTag,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return evStartChargingRequest.data;
};

export const cancelStartEvCharging = async (
  dataOwnerCustomerId: number,
  actingCustomerId: number,
  chargerId: string,
  socketId: string,
  rfidTag: string,
): Promise<EvChargingStatus> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const evCancelStartRequest: AxiosResponse<EvChargingStatus> = await API({
    method: 'post',
    url: `/v1/evCharging-cancelStart/${dataOwnerCustomerId}/${actingCustomerId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      chargerId,
      socketId,
      rfidTag,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return evCancelStartRequest.data;
};

export const stopEvCharging = async (
  dataOwnerCustomerId: number,
  actingCustomerId: number,
  chargerId: string,
  evseTransactionId: string,
): Promise<EvChargingStatus> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const evStopChargingRequest: AxiosResponse<EvChargingStatus> = await API({
    method: 'post',
    url: `/v1/evCharging-stop/${dataOwnerCustomerId}/${actingCustomerId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      chargerId,
      evseTransactionId,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return evStopChargingRequest.data;
};
export const fetchEvChargingStatus = async (
  dataOwnerCustomerId: number,
  actingCustomerId: number,
  chargerId: string,
  socketId: string,
  rfidTag: string,
  evseTransactionId: string,
): Promise<EvChargingStatus> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const evChargingStatusRequest: AxiosResponse<EvChargingStatus> = await API({
    method: 'get',
    url: `/v1/evCharging-getSession/${dataOwnerCustomerId}/${actingCustomerId}/${evseTransactionId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    params: {
      chargerId,
      socketId,
      rfidTag,
    },
  }).catch((error) => {
    if (error.response) {
      return error.response;
    }
  });

  return evChargingStatusRequest.data;
};
export const fetchEVChargingHistory = async (
  dataOwnerCustomerId: number,
  actingCustomerId: number,
  body: TransactionHistoryRequestUI,
): Promise<TransactionHistoryEventUI[]> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const evChargingHistoryRequest: AxiosResponse<TransactionHistoryEventUI[]> = await API({
    method: 'post',
    url: `/v1/evCharging-getHistory/${dataOwnerCustomerId}/${actingCustomerId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: body,
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return evChargingHistoryRequest.data;
};
